import React from "react"
import {
  WingsModal,
  WingsHeading,
  WingsText,
  WingsBadge,
} from "@wingspans-ui"
import { FormattedMessage } from "react-intl"
import "./ViewMilestoneModal.css"

const ViewMilestoneModal = ({ show, onClose, color, category, description, organization, timePeriod }) => {
  return (
    <WingsModal
      isOpen={show}
      onClose={onClose}
      size="md"
      className="view-milestone-modal"
      showCloseButton={true}
      dismissOnMask={true}
      dismissOnEscape={true}
    >
      <WingsModal.Header className="borderless-modal-section w-pt-2 w-px-2 w-pb-0">
        <WingsBadge backgroundColor={color}>
          {category}
        </WingsBadge>
      </WingsModal.Header>
      <WingsModal.Body className="w-px-2 w-pb-2 w-pt-1 w-flex w-flex-column w-gap-1 w-justify-start w-items-start">
        {description && (
          <div>
            <WingsHeading level={6} className="view-milestone-modal-label">
              <FormattedMessage id="career-plans-description" defaultMessage="Description" />
            </WingsHeading>
            <WingsText>
              {description}
            </WingsText>
          </div>
        )}
        
        {organization && (
          <div>
            <WingsHeading level={6} className="view-milestone-modal-label">
              <FormattedMessage id="career-plans-organization" defaultMessage="Organization" />
            </WingsHeading>
            <WingsText>
              {organization}
            </WingsText>
          </div>
        )}
        
        {timePeriod && (
          <div>
            <WingsHeading level={6} className="view-milestone-modal-label">
              <FormattedMessage id="career-plans-time-period" defaultMessage="Time Period" />
            </WingsHeading>
            <WingsText>
              {timePeriod}
            </WingsText>
          </div>
        )}
      </WingsModal.Body>
    </WingsModal>
  )
}

export default ViewMilestoneModal
